import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from '../../../style'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${({ row, color }) => (row ? `0 solid ${theme.transparent}` : `1px solid ${theme[color]}`)};
  border-right: ${({ row, color }) => (!row ? `0 solid ${theme.transparent}` : `1px solid ${theme[color]}`)};
`

const Divider = ({ row, color }) => (
    <Container row={row} color={color} />
)

Divider.propTypes = {
    row: PropTypes.bool,
    color: PropTypes.oneOf(Object.keys(theme)),
}

Divider.defaultProps = {
    row: false,
    color: 'greyLight3',
}

export default Divider
